<div class="dispute">
  <div class="dispute-content">
    <div class="dispute-content-body">
      @if (evidenceSubmitted) {
        <fui-rows>
          Evidence Submitted
        </fui-rows>
      }
      @if (model.dispute) {
        <fui-rows>
          <fui-row [label]="'fhm.dispute.dispute-information-title'">
            <fui-rows>
              <fui-row>
                <fui-text-control [label]="'Customer Name'" [value]="model.dispute.customerName"
                [readOnly]="true"></fui-text-control>
              </fui-row>
              <fui-row>
                <fui-two-columns>
                  <fui-column>
                    <fui-text-control [label]="'Customer Email'" [value]="model.dispute.customerEmail"
                    [readOnly]="true"></fui-text-control>
                  </fui-column>
                  <fui-column>
                    <fui-text-control [label]="'Customer Phone'" [value]="model.dispute.customerPhone"
                    [readOnly]="true"></fui-text-control>
                  </fui-column>
                </fui-two-columns>
              </fui-row>
              <fui-row>
                <fui-two-columns>
                  <fui-column>
                    <fui-numeric-control [label]="'Dispute Amount'"
                      [value]="model.dispute.disputeAmount" [notation]="'$'"
                    [readOnly]="true"></fui-numeric-control>
                  </fui-column>
                  <fui-column>
                    <fui-text-control [label]="'Location'" [value]="model.dispute.location"
                    [readOnly]="true"></fui-text-control>
                  </fui-column>
                </fui-two-columns>
              </fui-row>
              <fui-row>
                <fui-two-columns>
                  <fui-column>
                    <fui-text-control [label]="'Dispute On'" [value]="model.dispute.disputeDate"
                    [readOnly]="true"></fui-text-control>
                  </fui-column>
                  <fui-column>
                    <fui-text-control [label]="'Respond By'" [value]="model.dispute.disputeDueDate"
                    [readOnly]="true"></fui-text-control>
                  </fui-column>
                </fui-two-columns>
              </fui-row>
            </fui-rows>
          </fui-row>
          @if (evidenceSubmitted) {
            <fui-row [label]="'fhm.dispute.evidence-submitted-title'">
              Evidence was submitted and you will be notified with the dispute
            </fui-row>
          }
          @if (!evidenceSubmitted) {
            <fui-row [label]="'fhm.dispute.supporting-evidence-title'">
              <fui-rows>
                <fui-row class="info">
                  {{'fhm.dispute.supporting-evidence-info1' | translate}}
                </fui-row>
                <fui-row class="info">
                  {{'fhm.dispute.supporting-evidence-info2' | translate}}
                </fui-row>
                <fui-row>
                  <fhm-action-buttons>
                    <fui-commands [title]="'Upload Evidence'"
                      [showPopupForSingleItems]="false">
                      <fui-command (clicked$)="uploadMenu()"></fui-command>
                    </fui-commands>
                  </fhm-action-buttons>
                  <input #inputUploadFile class="input-upload-file" type="file"
                    (click)="inputUploadContractClick($event)"
                    (change)="fileSelected($event)">
                </fui-row>
                @for (evidenceFile of model.disputeEvidenceRequest.evidenceFiles; track evidenceFile) {
                  <fui-row>
                    <div class="evidence-file">
                      <div class="evidence-file-name">
                        {{evidenceFile.fileName}}
                      </div>
                      <div class="evidence-file-controls">
                        <div class="evidence-file-controls-control">
                          <fhm-evidence-type-select-control
                          (valueChange)="evidenceFile.evidenceType = $event"></fhm-evidence-type-select-control>
                          @if (submitAttempted && !evidenceFile.evidenceType) {
                            <div class="evidence-file-controls-control-error"
                              >
                              This file requires a category
                            </div>
                          }
                        </div>
                        <div class="evidence-file-controls-delete">
                          <fui-link-button class="action" [title]="'delete'"
                          (click)="deleteEvidenceFile(evidenceFile)"></fui-link-button>
                        </div>
                      </div>
                    </div>
                  </fui-row>
                }
              </fui-rows>
            </fui-row>
            <fui-row>
              <fui-textarea-control
                [label]="'fhm.dispute.additionalInformation'"
                [placeholder]="'fhm.common.label.no-label'"
              [(ngModel)]="model.disputeEvidenceRequest.additionalInformation"></fui-textarea-control>
            </fui-row>
          }
          <fui-row>
            <fui-buttons>
              @if (evidenceSubmitted) {
                <fui-action-button class="cancel-button"
                  [title]="'fhm.common.button.done'">
                  <fui-icon [height]="12" [icon]="'close'" [width]="12"></fui-icon>
                </fui-action-button>
              }
              @if (!evidenceSubmitted) {
                <fui-action-button [title]="'Submit'" (click)="submitEvidence()">
                  <fui-icon [height]="12" [icon]="'success'" [width]="12"></fui-icon>
                </fui-action-button>
              }
            </fui-buttons>
          </fui-row>
        </fui-rows>
      }
    </div>
  </div>
</div>
